import { gql } from 'graphql-request';

export const SUPER_ADMIN_NOTIFICATION_RECIPIENT_FIELDS = gql`
  fragment SuperAdminNotificationRecipientFields on SuperAdminNotificationRecipientDto {
    id
    email
    active
    notes
    createdById
    createdAt
    updatedAt
  }
`;

export const getSuperAdminNotificationRecipients = gql`
  query getSuperAdminNotificationRecipients {
    getSuperAdminNotificationRecipients {
      ...SuperAdminNotificationRecipientFields
    }
  }
  ${SUPER_ADMIN_NOTIFICATION_RECIPIENT_FIELDS}
`;

export const createSuperAdminNotificationRecipient = gql`
  mutation createSuperAdminNotificationRecipient(
    $input: SuperAdminNotificationRecipientCreateInput!
  ) {
    createSuperAdminNotificationRecipient(input: $input) {
      ...SuperAdminNotificationRecipientFields
    }
  }
  ${SUPER_ADMIN_NOTIFICATION_RECIPIENT_FIELDS}
`;

export const updateSuperAdminNotificationRecipient = gql`
  mutation updateSuperAdminNotificationRecipient(
    $input: SuperAdminNotificationRecipientUpdateInput!
  ) {
    updateSuperAdminNotificationRecipient(input: $input) {
      ...SuperAdminNotificationRecipientFields
    }
  }
  ${SUPER_ADMIN_NOTIFICATION_RECIPIENT_FIELDS}
`;

export const deleteSuperAdminNotificationRecipient = gql`
  mutation deleteSuperAdminNotificationRecipient($id: ID!) {
    deleteSuperAdminNotificationRecipient(id: $id)
  }
`;

const SuperAdminNotificationRecipientGraphQL = {
  queries: {
    getSuperAdminNotificationRecipients,
  },
  mutations: {
    createSuperAdminNotificationRecipient,
    updateSuperAdminNotificationRecipient,
    deleteSuperAdminNotificationRecipient,
  },
};

export default SuperAdminNotificationRecipientGraphQL;
